<template>
  <v-container class="py-0">
    <v-row class="px-4">
      <v-col
        cols="12"
        class="py-0"
      >
        <v-card-title class="pa-0">
          Delete Attendance
        </v-card-title>
      </v-col>
      <v-spacer />
    </v-row> 

    <v-row class="px-4">
      <v-col
        cols="12"
        class="py-0"
      >
        <v-data-table
          :items="months"
          :headers="headers"
          dense
          disable-pagination
          height="200px"
          hide-default-footer
          fixed-header
          :loading="tableLoading"
          class="elevation-2 mb-3"
        >
          <template v-slot:top>
            <h5 class="font-weight-bold py-2 mb-0 pl-2">
              Attendance Month:
            </h5>
          </template>
          <template v-slot:item.action="{ item }">
            <attendances-dialog-delete
              :month="item"
              @deleted="loadData"
            /> 
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      AttendancesDialogDelete: () => import('@/components/attendances/DialogDelete'),
    },
    data () {
      return {
        tableLoading: false,
        months: [],
        headers: [
          {
            text: 'Month',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.tableLoading = true

        this.$api.attendances().list()
          .then(res => {
            this.months = _.orderBy(res.data.map(monthYear => {
              return {
                id: this.$moment(monthYear, 'MM YYYY').format('YYYY-MM'),
                name: this.$moment(monthYear, 'MM YYYY').format('MMM YYYY'),
              }
            }), ['id'], ['desc'])   

            this.tableLoading = false
          })
      },
    },
   
  }
</script>
